import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  onCountdownComplete() {
    this.element.classList.add(
      'event-stream-container__placeholder-video--is-currently-live',
    );
  }
}
